"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCENT2_COLOR = exports.ACCENT_COLOR = exports.SECONDARY_COLOR = exports.PRIMARY_COLOR = exports.COMPANY_ZIP = exports.COMPANY_STATE = exports.COMPANY_COUNTRY = exports.COMPANY_CITY = exports.COMPANY_ADDRESS_LINE2 = exports.COMPANY_ADDRESS_LINE1 = exports.COMPANY_DOMAIN = exports.COMPANY_AVATAR = exports.COMPANY_LOGO_ALT_TEXT_MAX_LENGTH = exports.COMPANY_LOGO_ALT_TEXT = exports.COMPANY_LOGO_URL = exports.COMPANY_ADDRESS = exports.COMPANY_NAME = void 0;
var COMPANY_NAME = 'companyName';
exports.COMPANY_NAME = COMPANY_NAME;
var COMPANY_ADDRESS = 'companyAddress';
exports.COMPANY_ADDRESS = COMPANY_ADDRESS;
var COMPANY_LOGO_URL = 'companyLogoUrl';
exports.COMPANY_LOGO_URL = COMPANY_LOGO_URL;
var COMPANY_LOGO_ALT_TEXT = 'companyLogoAltText';
exports.COMPANY_LOGO_ALT_TEXT = COMPANY_LOGO_ALT_TEXT;
var COMPANY_LOGO_ALT_TEXT_MAX_LENGTH = 100;
exports.COMPANY_LOGO_ALT_TEXT_MAX_LENGTH = COMPANY_LOGO_ALT_TEXT_MAX_LENGTH;
var COMPANY_AVATAR = 'companyAvatar';
exports.COMPANY_AVATAR = COMPANY_AVATAR;
var COMPANY_DOMAIN = 'companyDomain';
exports.COMPANY_DOMAIN = COMPANY_DOMAIN;
var COMPANY_ADDRESS_LINE1 = 'companyAddressLine1';
exports.COMPANY_ADDRESS_LINE1 = COMPANY_ADDRESS_LINE1;
var COMPANY_ADDRESS_LINE2 = 'companyAddressLine2';
exports.COMPANY_ADDRESS_LINE2 = COMPANY_ADDRESS_LINE2;
var COMPANY_CITY = 'companyCity';
exports.COMPANY_CITY = COMPANY_CITY;
var COMPANY_COUNTRY = 'companyCountry';
exports.COMPANY_COUNTRY = COMPANY_COUNTRY;
var COMPANY_STATE = 'companyState';
exports.COMPANY_STATE = COMPANY_STATE;
var COMPANY_ZIP = 'companyZip';
exports.COMPANY_ZIP = COMPANY_ZIP;
var PRIMARY_COLOR = 'primaryColor';
exports.PRIMARY_COLOR = PRIMARY_COLOR;
var SECONDARY_COLOR = 'secondaryColor';
exports.SECONDARY_COLOR = SECONDARY_COLOR;
var ACCENT_COLOR = 'accentColor';
exports.ACCENT_COLOR = ACCENT_COLOR;
var ACCENT2_COLOR = 'accent2Color';
exports.ACCENT2_COLOR = ACCENT2_COLOR;